import React from "react";
import Cont from "./Cont/Cont";
import Touch from "./Touch/Touch";
import Location from "./Location/Location";
const Contact = () => {
  return (
    <>
      <Cont />
      <Touch />
      <Location />
    </>
  );
};

export default Contact;
